import {
  APPOINTMENT_TYPE_MINUTE_CAPS,
  type CappedMinuteField,
} from './appointment-types.constants';

/**
 * Rows saved before the caps existed may already hold larger values, so a value
 * equal to the stored one stays saveable. Pass no stored value on create.
 */
export function exceedsMinuteCap(
  field: CappedMinuteField,
  value: number,
  storedValue?: number,
): boolean {
  if (value === storedValue) return false;
  return value > APPOINTMENT_TYPE_MINUTE_CAPS[field];
}
